// extracted by mini-css-extract-plugin
module.exports = {"container":"ForkingPage_container__2JImQ"};